import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PaymentState } from './payment.state';

export const selectPaymentState =
  createFeatureSelector<PaymentState>('payment');

export const selectPayments = createSelector(
  selectPaymentState,
  (state: PaymentState) => state.payments
);

export const selectCurrentPayment = createSelector(
  selectPaymentState,
  (state: PaymentState) => state.payment
);

export const selectCurrentTransaction = createSelector(
  selectPaymentState,
  (state: PaymentState) => state.transaction
);

export const selectPaymentsFetchedAt = createSelector(
  selectPaymentState,
  (state: PaymentState) => state.fetchedAt
);

export const selectTransactionFetchedAt = createSelector(
  selectPaymentState,
  (state: PaymentState) => state.fetchedAt
);
